export default "__VITE_ASSET__DtOZVaoe__"